import GeoMap from '@/components/shared/geo-map';
import CustomModal from '@/components/ui/customModal';
import Input from '@/components/ui/input';
import { Address } from '@/graphql/graphql';
import { useTranslations } from 'next-intl';
import { Controller, useForm } from 'react-hook-form';
import { IoCloseOutline } from 'react-icons/io5';
import { Button, Modal } from 'rsuite';
import styles from './styles.module.scss';

type Props = {
  open: any;
  close: () => void;
  onSelectAddress: (data: Address) => void;
};

export default function MapModal({ open, close, onSelectAddress }: Props) {
  const t = useTranslations('Drawer.map-modal');
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
    reset,
    trigger,
    setValue,
  } = useForm<Address>({
    mode: 'onChange',
    defaultValues: {
      name: 'unknown',
      streetAddress: '',
      houseNumber: '',
      apartmentNumber: '',
      houseSection: '',
      floor: '',
      note: '',
    },
    criteriaMode: 'all',
  });

  const handleAddressSelected = (address: string, coords: number[]) => {
    setValue('streetAddress', address, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const onSubmit = (data: Address) => {
    onSelectAddress(data);
  };

  return (
    <CustomModal
      closeOnOutsideClick
      open={open}
      close={close}
      className={styles.modalMap}
    >
      <div className={styles.header}>
        <Modal.Title className={styles.headerTitle}>{t('title')}</Modal.Title>
        <IoCloseOutline onClick={close} className={styles.headerClose} />
      </div>
      <Modal.Body className={styles.modalBody}>
        <GeoMap onAddressSelect={handleAddressSelected} />
        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
          <div className={styles.formInputs}>
            <Controller
              name="streetAddress"
              control={control}
              rules={{ required: 'Адрес обязателен' }}
              render={({ field }) => (
                <Input
                  state={field.value}
                  setState={field.onChange}
                  label={t('address')}
                  error={errors}
                  name="streetAddress"
                  className={styles.inputMap}
                />
              )}
            />
            <div className={styles.inputGroup}>
              <Controller
                name="houseNumber"
                control={control}
                render={({ field }) => (
                  <Input
                    state={field.value || ''}
                    setState={field.onChange}
                    label={t('house')}
                    error={errors}
                    name="houseNumber"
                    className={styles.inputMap}
                  />
                )}
              />
              <Controller
                name="apartmentNumber"
                control={control}
                render={({ field }) => (
                  <Input
                    state={field.value || ''}
                    setState={field.onChange}
                    label={t('kv')}
                    error={errors}
                    name="apartmentNumber"
                    className={styles.inputMap}
                  />
                )}
              />
              <Controller
                name="houseSection"
                control={control}
                render={({ field }) => (
                  <Input
                    state={field.value || ''}
                    setState={field.onChange}
                    label={t('entrance')}
                    error={errors}
                    name="houseSection"
                    className={styles.inputMap}
                  />
                )}
              />
              <Controller
                name="floor"
                control={control}
                render={({ field }) => (
                  <Input
                    state={field.value || ''}
                    setState={field.onChange}
                    label={t('floor')}
                    error={errors}
                    name="floor"
                    className={styles.inputMap}
                  />
                )}
              />
            </div>
            <Controller
              name="note"
              control={control}
              render={({ field }) => (
                <Input
                  state={field.value || ''}
                  setState={field.onChange}
                  label={t('comment')}
                  error={errors}
                  name="note"
                  className={styles.comment}
                />
              )}
            />
          </div>
          <Button type="submit" className={styles.footerButton1}>
            {t('save')}
          </Button>
        </form>
      </Modal.Body>
    </CustomModal>
  );
}
